import { useCallback } from 'react';
import { getFeatureFlag } from '@root/helpers/feature-flags';

export const useFeatureFlags = () => useCallback(getFeatureFlag, []);
